<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-6" />
            <div class="col-md-2">
                <b-button id="create" variant="primary" class="btn-block"
                    @click="$router.push({ name: 'partner.create' })">
                    Create
                </b-button>
            </div>
        </div>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Identifier Id</th>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in datas" :key="index">
                                <td>{{ item.identifier_id || '-' }}</td>
                                <td>
                                    <b-img v-if="item.logo" height="50" :src="item.logo" :alt="item.name" />
                                    <span v-else>-</span>
                                </td>
                                <td>{{ item.name || '-' }}</td>
                                <td>{{ item.address || '-' }}</td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example">

                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                        <!-- <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" /> -->
                    </div>
                </div>
            </div>
        </b-card-code>
    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BDropdown, BDropdownItem, BSpinner,
    BFormGroup, BTabs, BTab, BNavItem, BPagination, BFormInput, BFormFile, BRow, BCol, BForm, BFormTextarea, BImg, BFormSelect, BFormTags,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'

import { optionsSelectTheme } from '@/utils/website_theme'
import FormTextarea from '@/components/FormTextarea.vue'
import FormInput from '@/components/FormInput.vue'

export default {
    title() {
        return 'Partner Management'
    },
    components: {
        BFormGroup,
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BDropdown,
        BDropdownItem,
        BTabs,
        BTab,
        BNavItem,
        BSpinner,
        BPagination,
        BFormInput,
        BFormFile,
        BRow,
        BCol,
        BForm,
        BFormTextarea,
        BImg,
        BFormSelect,
        BFormTags,
        FormTextarea,
        FormInput,
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
        filter: {
            handler: _.debounce(function () {
                this.getData()
            }, 300),
            deep: true,
        },
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
    },
    computed: {
        palettesFilter() {
            return this.options.find(item => item.value === this.formPayload.website_theme);
        }
    },
    data() {
        return {
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            // Form Repeater
            items: [{
                id: 1,
                emails: '',
                phone_numbers: '',
            }],
            itemGoogleTagIds: [{
                id: 1,
                website_google_tag_ids: '',
            }],
            itemGoogleAdsIds: [{
                id: 1,
                website_google_ads_ids: '',
            }],
            nextItemsId: 2,
            nextItemGoogleTagIds: 2,
            nextItemGoogleAdsIds: 2,

            result: Object,
            datas: [],
            isLoading: false,
            isLoadingImport: false,
            isLoadingExort: false,
            formPayload: {
                name: '',
                address: '',
                facebook: '',
                twitter: '',
                instagram: '',
                youtube: '',
                tiktok: '',
                logo: '',
                website_description: '',
                website_name: '',
                website_title: '',
                website_theme: '',
                website_keywords: [],
                website_google_tag_ids: [],
                website_google_ads_ids: [],
                website_favicon: null
            },
            detail: null,
            editId: null,
            filter: {
                search: '',
            },
            importPayload: {
                file: null,
            },
            options: optionsSelectTheme,
            mainProps: {
                blank: true,
                width: 25,
                height: 25,
            },
            validations: {},
            previewImage: null,
            previewFavicon: null
        }
    },
    mounted() {
        this.getData()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        // Form Repeat
        repeateAgain() {
            this.items.push({
                id: this.nextItemsId += this.nextItemsId,
            })
        },
        repeateFormGoogleTagIds() {
            this.itemGoogleTagIds.push({
                id: this.nextItemGoogleTagIds += this.nextItemGoogleTagIds,
            })
        },
        repeateFormGoogleAdsIds() {
            this.itemGoogleAdsIds.push({
                id: this.nextItemGoogleAdsIds += this.nextItemGoogleAdsIds,
            })
        },
        removeItem(index) {
            this.items.splice(index, 1)
        },
        removeItemGoogleTagIds(index) {
            this.itemGoogleTagIds.splice(index, 1)
        },
        removeItemGoogleAdsIds(index) {
            this.itemGoogleAdsIds.splice(index, 1)
        },
        // End Form Repeat

        async changeImage(event) {
            try {
                const files = event.target.files[0]
                const fileURL = URL.createObjectURL(files);
                this.previewImage = fileURL
                this.formPayload.logo = files
            } catch (error) {
                console.log(error);
            }
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                name: '',
                address: '',
                facebook: '',
                twitter: '',
                instagram: '',
                youtube: '',
                tiktok: '',
                logo: '',
                website_theme: '',
                website_description: '',
                website_name: '',
                website_title: '',
                website_keywords: []
            }
            this.items = [{
                id: 1,
                emails: '',
                phone_numbers: '',
            }]
            this.itemGoogleTagIds = [{
                id: 1,
                website_google_tag_ids: '',
            }]
            this.itemGoogleAdsIds = [{
                id: 1,
                website_google_ads_ids: '',
            }]
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage
            queryParams.limit = 10

            this.$http.get('/admin/partners', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.result = data;
                    this.datas = data.items
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                })
        },
        createItem() {
            const form = this.preparePayload()

            this.$http.post('/admin/partners', form, {
                headers: { 'content-type': 'multipart/form-data' },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Partner successfully created')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const form = this.preparePayload()

            this.$http.patch(`/admin/partners/${this.editId}`, form, {
                headers: { 'content-type': 'multipart/form-data' },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Partner successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    if (key != 'website_theme' && key != 'website_keywords') {
                        form.append(key, this.formPayload[key])
                    }
                    if (key == 'website_theme') {
                        form.append(key, this.formPayload[key].toLowerCase())
                    }
                    if (key == 'website_keywords') {
                        if (Array.isArray(this.formPayload.website_keywords)) {
                            this.formPayload.website_keywords.forEach((element, index) => {
                                form.append(`${key}[${index}]`, element);
                            });
                        }
                    }
                }
            }

            if (this.items.length) {
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['emails', 'phone_numbers'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }

            if (this.itemGoogleTagIds.length) {
                for (let index = 0; index < this.itemGoogleTagIds.length; index++) {
                    const element = this.itemGoogleTagIds[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['website_google_tag_ids'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }
            if (this.itemGoogleAdsIds.length) {
                for (let index = 0; index < this.itemGoogleAdsIds.length; index++) {
                    const element = this.itemGoogleAdsIds[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['website_google_ads_ids'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }

            return form
        },
        editItem(item) {
            this.$router.push({ name: 'partner.update', params: { id: item._id } });

        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete partner?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/partners/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Partner successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            const messages = error.response.data.meta.messages
                            // this.validations = validations
                            if (validations) {
                                for (const key in validations) {
                                    if (validations.hasOwnProperty(key)) {
                                        errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                    }
                                }
                            }
                            if (messages) {
                                errorNotification(this, 'Oops!', messages)
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
